import css from './AppSpinner.module.css';

const APP_SPINNER_COLOR = '#214028';

const blocks = [
  { x: 17, y: 17, begin: '0s' },
  { x: 40, y: 17, begin: '0.125s' },
  { x: 63, y: 17, begin: '0.25s' },
  { x: 63, y: 40, begin: '0.375s' },
  { x: 63, y: 63, begin: '0.5s' },
  { x: 40, y: 63, begin: '0.625s' },
  { x: 17, y: 63, begin: '0.75s' },
  { x: 17, y: 40, begin: '0.875s' },
] as const;

const AppSpinner = () => {
  return (
    <div className={css.SpinnerContainer}>
      <div className={css.SpinnerMedium}>
        <svg
          width="80"
          height="80"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          role="status"
          aria-label="Loading"
        >
          <title>Loading</title>
          <desc>Animated blocks indicating the page is loading</desc>
          {blocks.map(({ x, y, begin }) => (
            <rect
              key={`${x}-${y}`}
              x={x}
              y={y}
              width="20"
              height="20"
              fill={APP_SPINNER_COLOR}
              fillOpacity="0.35"
            >
              <animate
                attributeName="fill-opacity"
                values="1;0.35;0.35"
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin={begin}
                calcMode="discrete"
              />
            </rect>
          ))}
        </svg>
      </div>
    </div>
  );
};

export default AppSpinner;
